// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__oo9hB","wrapper-overlay":"loader_wrapper-overlay__P7+af","wrapper-centered":"loader_wrapper-centered__dIyQq"};